<template>

  <v-btn
    elevation   = "0"
    x-small
    :color      = "visible ? 'primary' : 'secondary'"
    @click      = "$emit('toggle')"
  >
    {{ label }}

    <v-icon
      right
      dark
    >
      {{ visible ? 'mdi-eye' : 'mdi-eye-off' }}
    </v-icon>

  </v-btn>

</template>

<script>

export default {

  // #region Properties

  props: {
    label:   String,
    visible: Boolean
  }

  // #endregion Properties

}

</script>